// /src/store/modalStore.js
import { create } from 'zustand';

// 1. Export the store definition directly
export const useModalStore = create((set) => ({
    isModalOpen: false,
    modalType: null,
    modalProps: {},

    openModal: (type, props = {}) => set((state) => ({ 
        ...state, 
        isModalOpen: true, 
        modalType: type, 
        modalProps: props 
    })),
    
    closeModal: () => set((state) => ({
        ...state,
        isModalOpen: false, 
        modalType: null, 
        modalProps: {}
    })),
}));

// 2. Export the openModal action from the store's state manager
// This allows calling it outside of React components/hooks.
export const openModalImperative = useModalStore.getState().openModal;